import React, { useLayoutEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import gsap from "gsap";

import ProductCategories from "../components/productshowcase";
import ManufacturingCapabilities from "../components/manufacturingcapabilities";
import IndustriesServed from "../components/industriesserved";

import product01 from "../assets/img/PNGs/FSC-certified-Paper-bags-for-food-delivery.png"
import product02 from "../assets/img/PNGs/Meal-and-Salad-Boxes.png"
import product03 from "../assets/img/PNGs/E-Commerce-Paper-Bags.png"
import product04 from "../assets/img/PNGs/Natural-materials-Packaging.png"





const images = {
  paperBag: product01,

  foodPackaging: product02,

  manufacturing: product03,

  packaging: product04,
};

function Products() {
  const heroRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        defaults: {
          ease: "power4.out",
        },
      });

      tl.from(".packaging-eyebrow", {
        y: 25,
        opacity: 0,
        duration: 0.7,
      })
        .from(
          ".packaging-title-line",
          {
            yPercent: 110,
            opacity: 0,
            duration: 1,
            stagger: 0.13,
          },
          "-=0.3"
        )
        .from(
          ".packaging-description",
          {
            y: 30,
            opacity: 0,
            duration: 0.8,
          },
          "-=0.5"
        )
        .from(
          ".packaging-points",
          {
            y: 25,
            opacity: 0,
            duration: 0.7,
          },
          "-=0.4"
        )
        .from(
          ".packaging-visual",
          {
            scale: 0.85,
            opacity: 0,
            duration: 1.2,
            ease: "power3.out",
          },
          "-=0.8"
        )
        .from(
          ".image-card",
          {
            scale: 0.7,
            opacity: 0,
            rotation: 8,
            duration: 0.9,
            stagger: 0.15,
            ease: "back.out(1.5)",
          },
          "-=0.8"
        );

      // Floating image animation
      gsap.to(".image-card-main", {
        y: -12,
        duration: 3.5,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
      });

      gsap.to(".image-card-small", {
        y: 15,
        duration: 4,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
      });

      gsap.to(".image-card-cert", {
        y: -10,
        duration: 3,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
      });

      // Rotating eco ring
      gsap.to(".eco-ring", {
        rotation: 360,
        duration: 20,
        repeat: -1,
        ease: "none",
      });

      // Parallax
      const handleMouseMove = (e) => {
        const x = (e.clientX / window.innerWidth - 0.5) * 25;
        const y = (e.clientY / window.innerHeight - 0.5) * 25;

        gsap.to(".packaging-visual", {
          x: x * 0.4,
          y: y * 0.4,
          duration: 1.2,
          ease: "power3.out",
        });

        gsap.to(".hero-copy", {
          x: -x * 0.12,
          y: -y * 0.12,
          duration: 1.2,
          ease: "power3.out",
        });
      };

      window.addEventListener("mousemove", handleMouseMove);

      return () => {
        window.removeEventListener("mousemove", handleMouseMove);
      };
    }, heroRef);

    return () => ctx.revert();
  }, []);

  return (
    <section>
    <div ref={heroRef} className="packaging-hero">
      <div className="packaging-grid" />

      <div className="hero-glow glow-one" />
      <div className="hero-glow glow-two" />

      <Container className="packaging-container py-lg-5 px-lg-5" fluid>
        <Row className="align-items-center">
          {/* CONTENT */}
          <Col lg={6}>
            <div className="hero-copy">
              {/* <div className="packaging-eyebrow">
                <span className="eyebrow-dot" />
                BUSINESS SEGMENT
                <span className="eyebrow-line" />
                ECO-FRIENDLY PACKAGING
              </div> */}

              <h1 className="packaging-title">
                <span className="title-mask">
                  <span className="packaging-title-line">
                    Eco-Friendly
                  </span>
                </span>

                <span className="title-mask">
                  <span className="packaging-title-line">
                    Packaging
                  </span>
                </span>

                <span className="title-mask">
                  <span className="packaging-title-line title-green">
                    Solutions.
                  </span>
                </span>
              </h1>

              <p className="packaging-description">
                Innovative, sustainable, and biodegradable packaging
                solutions for businesses committed to reducing
                environmental impact.
              </p>

              <div className="packaging-points">
                <div className="eco-point">
                  <span className="check">✓</span>
                  Sustainable Materials
                </div>

                <div className="eco-point">
                  <span className="check">✓</span>
                  Responsible Sourcing
                </div>

                <div className="eco-point">
                  <span className="check">✓</span>
                  International Standards
                </div>
              </div>

              <div className="packaging-cta">
                <button className="eco-button">
                  Explore Packaging
                  <span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="24" height="24">
  <path d="M14 50L50 14" fill="none" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M27 14H50V37" fill="none" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
</svg></span>
                </button>

                {/* <div className="cert-mini">
                  <span className="cert-leaf">♧</span>
                  <div>
                    <strong>RESPONSIBLE</strong>
                    <small>PACKAGING SOLUTIONS</small>
                  </div>
                </div> */}
              </div>
            </div>
          </Col>

          {/* VISUAL */}
          <Col lg={6}>
            <div className="packaging-visual">
              <div className="eco-ring">
                <span>•</span>
                <span>•</span>
                <span>•</span>
              </div>

              {/* Main paper bag */}
              <div className="image-card image-card-main">
                <img
                  src={images.paperBag}
                  alt="Eco-friendly paper bags"
                />

                {/* <div className="image-overlay">
                  <span>01</span>
                  <strong>Paper Bags</strong>
                </div> */}
              </div>

              {/* Food packaging */}
              <div className="image-card image-card-small">
                <img
                  src={images.foodPackaging}
                  alt="Food packaging paper"
                />

                {/* <div className="small-label">
                  FOOD PACKAGING
                </div> */}
              </div>

              {/* Manufacturing */}
              <div className="image-card image-card-process">
                <img
                  src={images.manufacturing}
                  alt="Packaging manufacturing process"
                />

                {/* <div className="process-label">
                  <span className="live-dot" />
                  MANUFACTURING
                </div> */}
              </div>

              {/* Certification */}
              <div className="image-card image-card-cert">
                <img
                  src={images.packaging}
                  alt="Sustainable packaging"
                />

                {/* <div className="cert-card">
                  <div className="cert-symbol">FSC</div>

                  <div>
                    <strong>RESPONSIBLY</strong>
                    <small>SOURCED</small>
                  </div>
                </div> */}
              </div>

              {/* Center badge */}
              {/* <div className="eco-badge">
                <div className="eco-badge-icon">↻</div>
                <span>CIRCULAR</span>
                <small>PACKAGING</small>
              </div> */}
            </div>
          </Col>
        </Row>

        {/* Bottom stats */}
        <div className="packaging-bottom">
           <div>
            <strong>01</strong>
            <span>Eco-Friendly<br />Production</span>
          </div>

          <div>
            <strong>02</strong>
            <span>Sustainable<br />Materials</span>
          </div>

          <div>
            <strong>03</strong>
            <span>Global Quality<br />Standards</span>
          </div>

          <div className="bottom-message">
            Designed for businesses.
            <span>Better for the planet.</span>
          </div>
        </div>
      </Container>
     </div>
      <ProductCategories/>
      <ManufacturingCapabilities/>
      <IndustriesServed/>
    </section>
  );
}

export default Products;